export const TRADING_TERMS = `
Handelsbetingelser (dummytekst):

1. Indledning
Din adgang til og brug af appen er underlagt disse handelsbetingelser. Ved at oprette en konto accepterer du dem.

2. Personlige oplysninger
Vi behandler dine data i henhold til gældende dansk og EU-lovgivning. Dine oplysninger deles ikke uden samtykke.

3. Tjeneste og ansvar
Appen leveres som den er. Vi kan ikke holdes ansvarlige for forkert brug eller medicinske beslutninger.

4. Afslutning
Du kan til enhver tid afslutte tjenesten. Vi kan suspendere konti ved brud på vilkårene.

(Dette er placeholder-tekst – rediger i src/constants/terms.js.)
`;